/**
 * Preferências de visibilidade dos atendentes na dashboard (por utilizador e empresa).
 * Guardadas em localStorage — sem alterações na base de dados.
 */

export const storageKey = (companyId, userId) =>
  `dashboard_attendant_visibility_v1_${companyId}_${userId}`;

export const loadDashboardAttendantVisibility = (companyId, userId) => {
  if (companyId == null || userId == null) {
    return { hiddenIds: [], coverageIds: [] };
  }
  try {
    const raw = localStorage.getItem(storageKey(companyId, userId));
    if (!raw) return { hiddenIds: [], coverageIds: [] };
    const o = JSON.parse(raw);
    return {
      hiddenIds: Array.isArray(o.hiddenIds)
        ? o.hiddenIds.map((n) => Number(n)).filter((n) => !Number.isNaN(n) && n > 0)
        : [],
      coverageIds: Array.isArray(o.coverageIds)
        ? o.coverageIds.map((n) => Number(n)).filter((n) => !Number.isNaN(n) && n > 0)
        : [],
    };
  } catch {
    return { hiddenIds: [], coverageIds: [] };
  }
};

export const saveDashboardAttendantVisibility = (companyId, userId, prefs) => {
  if (companyId == null || userId == null) return;
  const payload = {
    hiddenIds: Array.isArray(prefs.hiddenIds) ? prefs.hiddenIds : [],
    coverageIds: Array.isArray(prefs.coverageIds) ? prefs.coverageIds : [],
  };
  localStorage.setItem(storageKey(companyId, userId), JSON.stringify(payload));
};

/**
 * @param {Array<{ id: number, name?: string, [k: string]: any }>} rows
 */
export const applyDashboardAttendantVisibility = (rows, companyId, userId) => {
  const { hiddenIds, coverageIds } = loadDashboardAttendantVisibility(companyId, userId);
  const hidden = new Set(hiddenIds);
  const coverage = new Set(
    coverageIds.filter((id) => !hidden.has(id))
  );
  return (Array.isArray(rows) ? rows : [])
    .filter((a) => a && !hidden.has(Number(a.id)))
    .map((a) => ({
      ...a,
      coverageUser: coverage.has(Number(a.id)),
    }));
};
